<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-popup
      id="card-modal"
      :title="cardPopUpData.moduleName"
      :active.sync="showCardModal"
    >
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            :label="cardPopUpData.cardTitleLabel"
            :value="cardPopUpData.cardTitleValue"
            :disabled="true"
          />
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            :label="cardPopUpData.cardDescriptionLabel"
            :value="cardPopUpData.cardDescriptionValue"
            :disabled="true"
          />
        </div>
      </div>
      <br /><br />
      <vs-button
        color="primary"
        style="float:right!important;"
        type="filled"
        icon-pack="feather"
        icon="icon-external-link"
        @click="
          openNewWindow(cardPopUpData.moduleHash, cardPopUpData.recordHash)
        "
        >Visualizar Registro</vs-button
      >
    </vs-popup>
    <vs-popup
      id="migrate-modal"
      title="Migrar Cards"
      :active.sync="showMigrationModal"
      button-close-hidden
    >
      <!-- <vs-button color="danger" style="float:right!important;" type="filled" icon-pack="feather" icon="icon-x" @click="showEditModal = true">&nbsp;Cancelar</vs-button> -->
      <vs-button
        color="danger"
        style="float:right!important;"
        type="filled"
        icon-pack="feather"
        icon="icon-x"
        @click="closeMigrationModal"
      ></vs-button>
      <vs-button
        color="primary"
        class="mr-3"
        style="float:right!important;"
        type="filled"
        icon-pack="feather"
        icon="icon-save"
        @click="migrateCards"
      ></vs-button>
      <div class="vx-row mr-4">
        <div class="vx-col w-full">
          <label class="vs-input--label">Migrar cards para:</label>
          <div @click="onSelectClick" @focusout="onSelectBlur" class="mr-4">
            <v-select
              class="mr-4"
              :options="
                listOptions.filter(
                  x => x.hash !== null && x.hash !== currentListToDelete.hash
                )
              "
              v-model="listToMigrate"
              :clearable="false"
              label="name"
              name="migration-list"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-full">
          <div
            id="blank_content"
            style="height: 1px;"
            v-show="showBlankContent"
          ></div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      id="edit-modal"
      title="Editar Listas"
      :active.sync="showEditModal"
      button-close-hidden
    >
      <!-- <vs-button color="danger" style="float:right!important;" type="filled" icon-pack="feather" icon="icon-x" @click="showEditModal = true">&nbsp;Cancelar</vs-button> -->
      <vs-button
        color="danger"
        style="float:right!important;"
        type="filled"
        icon-pack="feather"
        icon="icon-x"
        @click="closeModal"
      ></vs-button>
      <vs-button
        color="primary"
        class="mr-3"
        style="float:right!important;"
        type="filled"
        icon-pack="feather"
        icon="icon-save"
        @click="saveKanbanLists"
      ></vs-button>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <h6 class="mt-5 mb-3">Inserir Nova Lista</h6>
          <vx-input-group class="mb-base mt-5">
            <vs-input
              v-model="listValue"
              maxlength="100"
              @keypress.enter="addList"
            />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="addList"
                ></vs-button>
              </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <h6 class="mt-5 mb-3">Listas</h6>
          <draggable
            :list="listOptions"
            :group="{ name: 'tags', pull: 'clone', put: false }"
            class="p-2 cursor-move"
          >
            <vs-chip
              color="primary"
              style="padding-left: 20px!important; padding-right: 20px!important;font-size: 1.0rem!important; min-width: 70px!important; min-height: 35px!important;"
              v-for="(listItem, index) in listOptions"
              :key="index"
            >
              <feather-icon
                v-if="listOptions[0]['name'] !== 'Adicione um item ...'"
                icon="XIcon"
                svgClasses="h-4 w-4 text-outline"
                class="mr-3"
                @click="deleteListDialog(index)"
                style="cursor: pointer!important; margin-left: -10px!important;"
              ></feather-icon>
              <feather-icon
                v-if="listOptions[0]['name'] !== 'Adicione um item ...'"
                :icon="listItem['visible'] ? 'EyeIcon' : 'EyeOffIcon'"
                svgClasses="h-4 w-4 text-outline"
                class="mr-2"
                @click="setVisible(index, listItem['visible'])"
                style="cursor: pointer!important; margin-left: -8px!important;"
              ></feather-icon>
              {{ listItem["name"] }}
            </vs-chip>
          </draggable>
        </div>
      </div>
    </vs-popup>
    <div class="vx-row p-4" style="float:right!important;">
      <div class="vx-col-12" style="float:right!important;">
        <vs-button
          color="primary"
          style="float:right!important;"
          type="filled"
          icon-pack="feather"
          icon="icon-edit-2"
          @click="showEditModal = true"
          >&nbsp;Editar</vs-button
        >
      </div>
    </div>
    <br /><br /><br />
    <vx-card :title="module.name">
      <ejs-kanban
        v-if="listOptions[0]['name'] !== 'Adicione um item ...'"
        id="kanban"
        cssClass="kanban-overview"
        keyField="status"
        :dataSource="kanbanData"
        :cardSettings="cardSettings"
        :cardRendered="cardRendered"
        :dragStop="onCardDragStop"
        :cardClick="onCardClick"
        :dialogOpen="dialogOpen"
        ref="KanbanObj"
      >
        <e-columns :allowDragAndDrop="true">
          <e-column
            v-for="list in kanbanList.filter(
              x => x.visible === true && x.hiddenByExpand === false
            )"
            :key="list['hash']"
            :headerText="list['name']"
            :keyField="`'${list['hash']}'`"
            :template="columnsTemplate"
          ></e-column>
        </e-columns>
      </ejs-kanban>
      <h6 v-else style="opacity: 0.5!important;">
        Sem colunas para serem exibidas.
      </h6>
    </vx-card>
  </div>
</template>

<script>
// import { DashboardLayoutComponent, DashboardLayoutPlugin } from '@syncfusion/ej2-vue-layouts'
// import { KanbanPlugin } from "@syncfusion/ej2-vue-kanban";
// import { extend, addClass } from "@syncfusion/ej2-base";
import Vue from "vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import { performFetch } from '../helpers.js'

export default {
  components: {
    KanbanPlugin,
    draggable,
    vSelect
  },
  data() {
    return {
      kanbanObj: null,
      cardPopUpData: {
        moduleHash: "",
        moduleName: "",
        cardTitleLabel: "",
        cardTitleValue: "",
        cardDescriptionLabel: "",
        cardDescriptionValue: "",
        recordHash: ""
      },
      showCardModal: false,
      cardModuleName: "",
      showBlankContent: false,
      module: {
        name: ""
      },
      visibleFieldsObject: {},
      dialogOpen: function(args) {
        args.cancel = true;
      },
      showEditModal: false,
      showMigrationModal: false,
      listToMigrate: {},
      listValue: "",
      listOptions: [{ hash: null, name: "Adicione um item..." }],
      kanbanList: [],
      colorsList: [
        "First",
        "Second",
        "Third",
        "Fourth",
        "Fiveth",
        "Sixth",
        "Seventh"
      ],
      kanbanData: [],
      enableTooltip: false,
      // tooltipTemplate: tooltipTemplate,
      columnsTemplate: function() {
        return {
          template: Vue.component("columnsTemplate", {
            template: `
              <div class="header-template-wrap" style="display: flex;justify-content:space-around;">
                <div class="header-text">{{data.headerText}}</div>&nbsp;- {{ data.count }}
              </div>`,

            // <feather-icon v-if="$store.state.kanban.maximizeColumn[data.keyField.replace(/'/g,'')].type === 'minimize'" @click="$store.commit('kanban/MAXIMIZE_COLUMN', {hash: data.keyField.replace(/'/g,''), type: 'maximize'})" icon="Maximize2Icon" svgClasses="h-4 w-4 text-outline" class="ml-3" style="float:right!important;cursor: pointer;"></feather-icon>
            // <feather-icon v-if="$store.state.kanban.maximizeColumn[data.keyField.replace(/'/g,'')].type !== 'minimize'" @click="$store.commit('kanban/MAXIMIZE_COLUMN', {hash: data.keyField.replace(/'/g,''), type: 'minimize'})" icon="Minimize2Icon" svgClasses="h-4 w-4 text-outline" class="ml-3" style="float:right!important;cursor: pointer;"></feather-icon>
            // <feather-icon @click="$store.commit('kanban/MAXIMIZE_COLUMN', {data: {...data, ...{type: 'maximize'}}})" icon="Maximize2Icon" svgClasses="h-4 w-4 text-outline" class="ml-3" style="float:right!important;cursor: pointer;"></feather-icon>
            data() {
              return {
                data: {}
              };
            },
            methods: {
              getClassName: function(data) {
                return "header-icon e-icons " + data.keyField;
              }
            }
          })
        };
      },
      cardSettings: {
        template: () => {
          return {
            template: Vue.component("cardTemplate", {
              template: `
                <div class="card-template">
                  <div class="e-card-header">
                    <div class="e-card-header-caption">
                      <div class="e-card-header-title e-tooltip-text" style="font-size: 14px!important;font-weight: 500!important;line-height: 1.625!important;">{{data.title}}</div>
                    </div>
                  </div>
                  <div class="e-card-content e-tooltip-text" style="font-size: 14px!important;padding: 8px 14px!important;line-height: 1.625!important;">
                    <div class="e-text">{{data.description}}</div>
                  </div>
                  <div class="e-card-custom-footer">
                    <div class="e-card-tag-field e-tooltip-text">{{data.moduleName}}</div>
                    <div class="e-card-avatar"
                    :style="{
                      width: '43px',
                      height: '43px',
                      textAlign: 'center',
                      backgroundColor: '#dcdcdc',
                      color: '#6b6b6b',
                      borderRadius: '50%',
                      position: 'absolute',
                      right: '12px',
                      bottom: '10px',
                      fontSize: data.fontSize + 'px',
                      fontWeight: '400',
                      padding: '16px 0 0 1px'
                    }
                    "
                    >{{data.cardPrefix.replace(' - ', '')}}</div>
                  </div>
                </div>
              `
            })
          };
        },
        titleField: "text",
        contentField: "description",
        headerField: "id",
        grabberField: "color"
      },
      titleFieldHash: "",
      indexFieldHash: "",
      visibleFieldHash: "",
      assignedToIdHash: "",
      currentListToDelete: {
        hash: "",
        index: null
      },
      dataModel: {},
      timer: null
    };
  },
  mounted() {
    // document.title = `${document.title.split(' | ')[0]  } | Kanban`
    this.kanbanObj = this.$refs.KanbanObj.ej2Instances;
  },
  async created() {
    this.$vs.loading({ type: "default" });
    await this.getKanbanFields();
    await this.getModuleLists();
    await this.getKanbanData();
    // this.timer = setInterval(() => {
    //   this.getKanbanData()
    // }, 20000)
    this.changeNoCardsMessage();
    setTimeout(() => {
      const kanbanHtml = document.querySelector(
        "div.e-kanban-content > div > table > tbody > tr"
      ).childNodes;
      kanbanHtml.forEach(async column => {
        const divElement = document.createElement("div");
        divElement.style.position = "absolute";
        divElement.style.position = "absolute";
        divElement.style.bottom = "15px";
        const spanElement = document.createElement("span");
        spanElement.style.marginLeft = "15px";
        spanElement.style.fontWeight = "500";
        spanElement.style.fontSize = "15px";
        const divData = await this.getFooterInfo(
          column.getAttribute("data-key").replace(/'/g, "")
        );
        spanElement.innerHTML = divData;
        divElement.appendChild(spanElement);
        column.appendChild(divElement);
      });
    }, 300);
    this.$vs.loading.close();
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    next();
  },
  watch: {
    async "$route.params.moduleHash"() {
      this.$vs.loading({ type: "default" });
      this.resetPageData();
      await this.getKanbanFields();
      await this.getModuleLists();
      await this.getKanbanData();
      // this.timer = setInterval(() => {
      //   this.getKanbanData()
      // }, 20000)
      this.changeNoCardsMessage();
      setTimeout(() => {
        const kanbanHtml = document.querySelector(
          "div.e-kanban-content > div > table > tbody > tr"
        ).childNodes;
        kanbanHtml.forEach(async column => {
          const divElement = document.createElement("div");
          divElement.style.position = "absolute";
          divElement.style.position = "absolute";
          divElement.style.bottom = "15px";
          const spanElement = document.createElement("span");
          spanElement.style.marginLeft = "15px";
          spanElement.style.fontWeight = "500";
          spanElement.style.fontSize = "15px";
          const divData = await this.getFooterInfo(
            column.getAttribute("data-key").replace(/'/g, "")
          );
          spanElement.innerHTML = divData;
          divElement.appendChild(spanElement);
          column.appendChild(divElement);
          // column.appendChild('footer')
        });
      }, 300);

      this.$vs.loading.close();
    },
    showCardModal(value) {
      if (!value) {
        document
          .querySelector(".con-vs-popup#card-modal div.vs-popup")
          .setAttribute(
            "style",
            "width: 1200px!important;height: auto!important"
          );

        this.cardPopUpData.moduleHash = "";
        this.cardPopUpData.moduleName = "";
        this.cardPopUpData.cardTitleLabel = "";
        this.cardPopUpData.cardTitleValue = "";
        this.cardPopUpData.cardDescriptionLabel = "";
        this.cardPopUpData.cardDescriptionValue = "";
        this.cardPopUpData.recordHash = "";
      }
    }
  },
  methods: {
    resetPageData() {
      this.cardPopUpData = {
        moduleHash: "",
        moduleName: "",
        cardTitleLabel: "",
        cardTitleValue: "",
        cardDescriptionLabel: "",
        cardDescriptionValue: "",
        recordHash: ""
      };
      this.showCardModal = false;
      this.cardModuleName = "";
      this.showBlankContent = false;
      this.module = {
        name: ""
      };
      this.visibleFieldsObject = {};
      this.showEditModal = false;
      this.showMigrationModal = false;
      this.listToMigrate = {};
      this.listValue = "";
      this.listOptions = [{ hash: null, name: "Adicione um item..." }];
      this.kanbanList = [];
      this.kanbanData = [];
      this.enableTooltip = false;
      this.titleFieldHash = "";
      this.indexFieldHash = "";
      this.visibleFieldHash = "";
      this.assignedToIdHash = "";
      (this.currentListToDelete = {
        hash: "",
        index: null
      }),
        (this.dataModel = {});
      this.timer = null;
    },
    async getFooterInfo(columnHash) {
      return new Promise(resolve => {
        setTimeout(() => {
          // resolve('Valor Total: R$ 43.547,42 - Total de Equipamentos: 231')
          resolve("");
        }, 1000);
      });
    },
    refreshUI() {
      this.kanbanObj.refreshHeader();
    },
    openNewWindow(moduleHash, recordHash) {
      const newWindowRoute = this.$router.resolve(
        "/modules/view/" + moduleHash + "/" + recordHash
      );
      window.open(newWindowRoute.href, "_blank");
    },
    onCardClick(event) {
      document
        .querySelector(".con-vs-popup#card-modal div.vs-popup")
        .setAttribute("style", "width: 700px!important;height: auto!important");

      this.showCardModal = true;

      this.cardPopUpData.moduleHash = event.data.moduleHash;
      this.cardPopUpData.recordHash = event.data.id;
      this.cardPopUpData.moduleName = event.data.moduleName;
      this.cardPopUpData.cardTitleValue = event.data.title;
      this.cardPopUpData.cardTitleLabel = event.data.titleLabel;
      this.cardPopUpData.cardDescriptionValue = event.data.description;
      this.cardPopUpData.cardDescriptionLabel = event.data.descriptionLabel;
    },
    onSelectBlur() {
      if (this.showBlankContent) {
        try {
          document.querySelector("#blank_content").style.height = "1px";

          this.showBlankContent = false;
        } catch (e) {
          //
        }
      }
    },
    onSelectClick() {
      if (!this.showBlankContent) {
        try {
          const offsetHeight = document.querySelector(".vs__dropdown-menu")
            .offsetHeight;

          document.querySelector("#blank_content").style.height =
            offsetHeight + "px";

          this.showBlankContent = true;
        } catch (e) {
          //
        }
      }
    },
    changeNoCardsMessage() {
      setTimeout(() => {
        document.querySelectorAll(".e-empty-card").forEach(item => {
          item.innerHTML = "Sem cards à serem exibidos";
        });
      }, 300);
    },
    async onCardDragStop(event) {
      try {
        this.$vs.loading({ type: "default" });
        const newListHash = event.data[0].status.replace(/'/g, "");
        const moduleHash = event.data[0].moduleHash;
        const rowHash = event.data[0].id;
        const requestObject = {};
        requestObject[event.data[0].statusFieldHash] = newListHash;
        await this.updateCardStatus(moduleHash, rowHash, requestObject);
        this.changeNoCardsMessage();
        this.$vs.loading.close();
      } catch (e) {
        //
        this.$vs.loading.close();
      }
      this.$vs.loading.close();
    },
    async updateCardStatus(
      moduleHash,
      rowHash,
      dataUpdateObject,
      showPopUp = true
    ) {
      return new Promise(async (resolve, reject) => {
        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: "POST", headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: "update_module_row",
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token,
        //       module_token: moduleHash,
        //       row_hash: rowHash,
        //       data: dataUpdateObject
        //     }
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
            command: "update_module_row",
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              module_token: moduleHash,
              row_hash: rowHash,
              data: dataUpdateObject
            }
          })
          .then(async response => {
            if (response.status === 200) {
              this.refreshUI();
              if (showPopUp) {
                this.$vs.notify({
                  title: "Operação realizada!",
                  text: "Card atualizado com sucesso!",
                  iconPack: "feather",
                  icon: "icon-check-circle",
                  color: "success"
                });
              }
              resolve(true);
            } else if (response.status == 401) {
              this.$vs.loading.close();
              this.showEditModal = false;
              resolve(false);
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else if (response.status === 400) {
              this.$vs.loading.close();
              response.json().then(responseData => {
                this.$vs.loading.close();
                this.showEditModal = false;
                this.$vs.notify({
                  title: "Operação não realizada!",
                  text: responseData.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning"
                });
              });
              resolve(false);
            } else {
              this.$vs.loading.close();
              this.showEditModal = false;
              this.$vs.notify({
                title: "Operação não realizada!",
                text: "Ocorreu um erro ao salvar o registro",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
              resolve(false);
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação não realizada!",
              text: e.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
            throw new Error(e.message);
          });
      });
    },
    cardRendered(args) {
      addClass([args.element], args.data.classColor);
    },
    async getKanbanData() {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "get_application_kanban_data",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_hash: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "get_application_kanban_data",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_hash: this.$route.params.moduleHash
          }
        })
        .then(async response => {
          this.$vs.loading.close();
          if (response.status === 200) {
            response.json().then(responseData => {
              const cardsData = [];

              responseData.payload.forEach((kanbanItem, kanbanIndex) => {
                const moduleClassColor = this.colorsList[kanbanIndex];
                let moduleHash = kanbanItem.module_hash;
                let moduleName = kanbanItem.module_name;

                kanbanItem.module_cards.forEach(item => {
                  const itemId = item.identification;
                  let itemTitle = "";
                  let titleLabel = "";
                  let itemDescription = "";
                  let titleDescription = "";
                  let itemStatus = "";
                  let statusFieldHash = "";
                  let cardPrefix = "";
                  let fontSize = 12;

                  Object.keys(item.items).forEach(field => {
                    cardPrefix = item.identifier;
                    if (item.items[field]["kanban_type_field"] === "title") {
                      itemTitle = item.items[field]["payload"];
                      titleLabel = item.items[field]["title"];
                    } else if (
                      item.items[field]["kanban_type_field"] === "description"
                    ) {
                      itemDescription = item.items[field]["payload"];
                      titleDescription = item.items[field]["title"];
                    } else if (
                      item.items[field]["kanban_type_field"] === "core"
                    ) {
                      itemStatus = `'${item.items[field]["payload"]}'`;
                      statusFieldHash = item.items[field]["hash"];
                    }
                  });

                  if (cardPrefix.length === 4) {
                    fontSize = 10;
                  } else if (cardPrefix > 4) {
                    fontSize = 9;
                  }

                  cardsData.push({
                    id: itemId,
                    title: itemTitle,
                    titleLabel: titleLabel,
                    description: itemDescription,
                    descriptionLabel: titleDescription,
                    status: itemStatus,
                    moduleHash: moduleHash,
                    moduleName: moduleName,
                    cardPrefix: cardPrefix,
                    fontSize: fontSize,
                    classColor: moduleClassColor,
                    statusFieldHash: statusFieldHash
                  });
                });
              });

              this.kanbanData = JSON.parse(JSON.stringify(cardsData));
              this.kanbanObj.kanbanData = JSON.parse(JSON.stringify(cardsData));
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            // this.$vs.notify({
            //   title: 'Operação não realizada!',
            //   text: 'Ocorreu um erro ao buscar os dados do kanban!',
            //   iconPack: 'feather',
            //   icon: 'icon-check',
            //   color: 'danger'
            // })
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          // this.$vs.notify({
          //   title: 'Operação não realizada!',
          //   text: 'Ocorreu um erro ao buscar os dados do kanban!',
          //   iconPack: 'feather',
          //   icon: 'icon-check',
          //   color: 'danger'
          // })
          throw new Error(e.message);
        });
    },
    closeModal() {
      if (
        JSON.stringify(this.kanbanList) !== JSON.stringify(this.listOptions)
      ) {
        this.showEditModal = false;
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Confirmar",
          text:
            "Você tem certeza que deseja cancelar ? As alterações realizadas serão perdidas",
          accept: () => {
            this.listOptions = JSON.parse(JSON.stringify(this.kanbanList));
            this.showEditModal = false;
          },
          acceptText: "Cancelar",
          cancelText: "Continuar",
          cancel: () => {
            this.showEditModal = true;
          }
        });
      } else {
        this.showEditModal = false;
      }
    },
    closeMigrationModal() {
      this.showEditModal = true;
      this.showMigrationModal = false;
      this.currentListToDelete["hash"] = "";
      this.currentListToDelete["index"] = null;
    },
    async getKanbanFields() {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "module_management_get_application_module_fields",
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       module_token: this.$route.params.moduleHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "module_management_get_application_module_fields",
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            module_token: this.$route.params.moduleHash
          }
        })
        .then(async response => {
          if (response.status === 200) {
            response.json().then(async responseData => {
              this.$store.commit(
                "auth/SET_CURRENT_MODULE_NAME",
                responseData.module.name
              );

              const dataBlock = responseData.module.payload.find(
                x => x.index === 1
              );
              const systemDataBlock = responseData.module.payload.find(
                x => x.index === 2
              );

              const titleFieldHash = dataBlock.fields.find(
                x => x.name === "title"
              ).hash;
              const indexFieldHash = dataBlock.fields.find(
                x => x.name === "index"
              ).hash;
              const visibleFieldHash = dataBlock.fields.find(
                x => x.name === "visible"
              ).hash;
              const assignedToIdFieldHash = systemDataBlock.fields.find(
                x => x.name === "assigned_to_id"
              ).hash;

              this.titleFieldHash = titleFieldHash;
              this.indexFieldHash = indexFieldHash;
              this.visibleFieldHash = visibleFieldHash;
              this.assignedToIdFieldHash = assignedToIdFieldHash;
            });
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação não realizada!",
              text: "Ocorreu um erro ao buscar os módulos da aplicação!",
              iconPack: "feather",
              icon: "icon-check",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Operação não realizada!",
            text: "Ocorreu um erro ao buscar os módulos da aplicação!",
            iconPack: "feather",
            icon: "icon-check",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    async getModuleLists() {
      const parametersObject = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.$route.params.moduleHash,
        per_page: 1000,
        page: 1,
        give_options: false
      };

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "list_module_rows",
      //     parameters: parametersObject
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: "list_module_rows",
          parameters: parametersObject
        })
        .then(response => {
          if (response.status === 200) {
            response
              .json()
              .then(responseData => {
                this.module.name = responseData.detail.module_name;
                this.listOptions = [
                  { hash: null, name: "Adicione um item ..." }
                ];
                this.kanbanList = [];
                if (responseData.payload.length > 0) {
                  this.listOptions.splice(0, 1);
                  const payloadOrdered = responseData.payload.sort((a, b) => {
                    if (
                      a["items"]["index"]["payload"] <
                      b["items"]["index"]["payload"]
                    ) {
                      return -1;
                    }
                    if (
                      a["items"]["index"]["payload"] >
                      b["items"]["index"]["payload"]
                    ) {
                      return 1;
                    }

                    return 0;
                  });

                  payloadOrdered.forEach(item => {
                    this.listOptions.push({
                      hash: item.items.hash.payload,
                      name: item.items.title.payload,
                      visible: item.items.visible.payload,
                      hiddenByExpand: false
                    });

                    this.kanbanList.push({
                      hash: item.items.hash.payload,
                      name: item.items.title.payload,
                      visible: item.items.visible.payload,
                      hiddenByExpand: false
                    });
                  });
                }
              })
              .catch(e => {
                this.$vs.notify({
                  title: "Atenção!",
                  text: e.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger"
                });
                throw new Error(e.message);
              });
          } else if (response.status === 400) {
            this.$router.push(`/modules/view/${this.$route.params.moduleHash}`);
          } else if (response.status === 403) {
            this.showEmptyDataMessage = true;
          } else if (response.status === 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            this.$store.dispatch("auth/signOut");
          } else {
            this.$vs.notify({
              title: "Operação não realizada!",
              text: "Ocorreu um erro ao listar os registros do módulo",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Atenção!",
            text: e.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          throw new Error(e.message);
        });
    },
    validateAddKanbanListsForm() {
      if (this.listOptions[0]["name"] === "Adicione um item...") {
        this.$vs.notify({
          title: "Atenção",
          text: "É necessário adicionar uma lista!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }

      return true;
    },
    async addModuleRow(requestBody) {
      return new Promise(async (resolve, reject) => {
        // await fetch(`${this.$store.state.auth.api_url}`, {
        //   method: "POST", headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: "add_module_row",
        //     parameters: requestBody
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
            command: "add_module_row",
            parameters: requestBody
          })
          .then(async response => {
            if (response.status === 200) {
              resolve(true);
            } else if (response.status == 401) {
              this.$vs.loading.close();
              this.showEditModal = false;
              resolve(false);
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else if (response.status === 400) {
              this.$vs.loading.close();
              response.json().then(responseData => {
                this.$vs.loading.close();
                this.showEditModal = false;
                this.$vs.notify({
                  title: "Operação não realizada!",
                  text: responseData.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning"
                });
              });
              resolve(false);
            } else {
              this.$vs.loading.close();
              this.showEditModal = false;
              this.$vs.notify({
                title: "Operação não realizada!",
                text: "Ocorreu um erro ao salvar o registro",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
              resolve(false);
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação não realizada!",
              text: e.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
            throw new Error(e.message);
          });
      });
    },
    async updateModuleRow(rowHash, fieldData) {
      return new Promise(async (resolve, reject) => {
        await performFetch(this.$store.state.auth.api_url, {
            command: "update_module_row",
            parameters: {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              module_token: this.$route.params.moduleHash,
              row_hash: rowHash,
              data: fieldData
            }
          })
          .then(async response => {
            if (response.status === 200) {
              resolve(true);
            } else if (response.status == 401) {
              this.$vs.loading.close();
              this.showEditModal = false;
              resolve(false);
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else if (response.status === 400) {
              this.$vs.loading.close();
              response.json().then(responseData => {
                this.$vs.loading.close();
                this.showEditModal = false;
                this.$vs.notify({
                  title: "Operação não realizada!",
                  text: responseData.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning"
                });
              });
              resolve(false);
            } else {
              this.$vs.loading.close();
              this.showEditModal = false;
              this.$vs.notify({
                title: "Operação não realizada!",
                text: "Ocorreu um erro ao salvar o registro",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
              resolve(false);
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação não realizada!",
              text: e.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
            throw new Error(e.message);
          });
      });
    },
    async saveKanbanLists() {
      if (this.validateAddKanbanListsForm()) {
        console.log("here");

        this.$vs.loading({ type: "default" });

        for (let i = 0; i < this.listOptions.length; i++) {
          if (this.listOptions[i]["hash"] === null) {
            const requestBody = {
              application_token: this.$store.state.auth.app_token,
              session_token: this.$store.state.auth.token,
              module_token: this.$route.params.moduleHash,
              data: {}
            };

            requestBody.data[this.titleFieldHash] = this.listOptions[i]["name"];
            requestBody.data[this.indexFieldHash] = i + 1;
            requestBody.data[
              this.assignedToIdFieldHash
            ] = this.$store.state.auth.user.hash;
            requestBody.data[this.visibleFieldHash] = true;

            await this.addModuleRow(requestBody);
          } else {
            if (
              JSON.stringify(this.listOptions[i]) !==
                JSON.stringify(this.kanbanList[i]) ||
              this.listOptions[i]["name"] !== this.kanbanList[i]["name"]
            ) {
              const updateModuleRowObject = {};

              updateModuleRowObject[this.indexFieldHash] = i + 1;

              await this.updateModuleRow(
                this.listOptions[i]["hash"],
                updateModuleRowObject
              );
            }
          }
        }

        await this.getModuleLists();

        this.changeNoCardsMessage();

        this.$vs.loading.close();

        this.$vs.notify({
          title: "Operação Realizada!",
          text: "Listas cadastradas com sucesso!",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success"
        });

        this.showEditModal = false;
      }
    },
    async migrateCards() {
      if (JSON.stringify(this.listToMigrate) === "{}") {
        this.$vs.notify({
          title: "Atenção!",
          text: "É necessário selecionar ao menos uma lista!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return;
      } else {
        this.$vs.loading({ type: "default" });

        let oldListCards = this.kanbanData.filter(
          x => x.status === `'${this.currentListToDelete.hash}'`
        );

        for (let i = 0; i < oldListCards.length; i++) {
          const moduleHash = oldListCards[i].moduleHash;
          const rowHash = oldListCards[i].id;
          const requestObject = {};
          requestObject[
            oldListCards[i].statusFieldHash
          ] = this.listToMigrate.hash;
          this.kanbanData[i].status = `'${this.listToMigrate.hash}'`;
          await this.updateCardStatus(
            moduleHash,
            rowHash,
            requestObject,
            false
          );
        }

        let kanbanData = this.kanbanData;
        this.kanbanData = [];
        this.kanbanData = JSON.parse(JSON.stringify(kanbanData));

        this.$vs.notify({
          title: "Operação realizada!",
          text: "Cards migrados com sucesso!!",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success"
        });

        this.listToMigrate = {};
        this.showMigrationModal = false;
        this.acceptDeleteList();

        this.$vs.loading.close();
      }
    },
    addList() {
      if (this.listValue === "") {
        this.$vs.notify({
          title: "Atenção",
          text: "O item não pode ser vazio!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return;
      }

      if (this.listOptions[0].name === "Adicione um item ...") {
        this.listOptions = [];
      }

      this.listOptions.push({
        hash: null,
        name: this.listValue,
        visible: true
      });
      this.listValue = "";
    },
    deleteListDialog(listIndex) {
      this.showEditModal = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirmar",
        text: "Você tem certeza que deseja excluir este item ?",
        accept: async () => {
          this.currentListToDelete["hash"] = this.listOptions[listIndex][
            "hash"
          ];
          this.currentListToDelete["index"] = listIndex;
          const listCards = this.kanbanData.filter(
            x => x.status === `'${this.listOptions[listIndex]["hash"]}'`
          );
          if (listCards.length > 0) {
            this.showMigrationModal = true;
          } else {
            this.acceptDeleteList();
          }
        },
        acceptText: "Excluir",
        cancelText: "Cancelar",
        cancel: () => {
          this.showEditModal = true;
        }
      });
    },
    async addColumnFooter() {
      //
    },
    async acceptDeleteList() {
      if (this.currentListToDelete.hash !== null) {
        this.$vs.loading({ type: "default" });
        await this.deleteList(this.currentListToDelete.hash);
        await this.getModuleLists();
        this.$vs.loading.close();
        this.showEditModal = true;
      } else {
        this.listOptions.splice(this.currentListToDelete.index, 1);
        this.kanbanList.splice(this.currentListToDelete.index, 1);
        if (this.listOptions.length === 0)
          this.listOptions[0] = { hash: null, name: "Adicione um item ..." };
        this.$vs.notify({
          title: "Operação Realizada!",
          text: "Lista excluída",
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success"
        });
        this.showEditModal = true;
      }
    },
    setVisible(listIndex, currentValue) {
      let value = !currentValue;

      const setListVisible = async () => {
        if (this.listOptions[listIndex]["hash"] !== null) {
          this.$vs.loading({ type: "default" });
          const updateModuleRowObject = {};
          updateModuleRowObject[this.visibleFieldHash] = value;
          await this.updateModuleRow(
            this.listOptions[listIndex]["hash"],
            updateModuleRowObject
          );
          await this.getModuleLists();
          this.$vs.loading.close();
          this.showEditModal = true;
        } else {
          this.listOptions[listIndex]["visible"] = !currentValue;
          this.$vs.notify({
            title: "Operação Realizada!",
            text: value ? "Lista reexibida" : "Lista ocultada",
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success"
          });
          this.showEditModal = true;
        }
      };

      if (!value) {
        this.showEditModal = false;
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Confirmar",
          text: "Você tem certeza que deseja ocultar esta lista ?",
          accept: setListVisible,
          acceptText: "Ocultar",
          cancelText: "Cancelar",
          cancel: () => {
            this.showEditModal = true;
          }
        });
      } else {
        setListVisible();
      }
    },
    async deleteList(listHash) {
      return new Promise(async (resolve, reject) => {
        const requestBody = {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: this.$route.params.moduleHash,
          row_hash: listHash
        };

        await performFetch(this.$store.state.auth.api_url, {
            command: "delete_module_row",
            parameters: requestBody
          })
          .then(async response => {
            if (response.status === 200) {
              this.$vs.loading.close();

              this.$vs.notify({
                title: "Operação Realizada!",
                text: "Lista excluída",
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success"
              });

              resolve(true);
            } else if (response.status == 401) {
              setApplicationLocalStorageItem(
                "lastUrl",
                btoa(window.location.pathname)
              );
              this.$store.dispatch("auth/signOut");
            } else if (response.status == 403) {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Atenção!",
                text:
                  "Você não tem permissão para deletar registros neste módulo!",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning"
              });
              resolve(false);
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Operação não realizada!",
                text: "Ocorreu um erro ao deletar o registro",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
              resolve(false);
            }
          })
          .catch(e => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Operação não realizada!",
              text: e.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
            throw new Error(e.message);
          });
      });
    }
  }
};
</script>
<style scoped>
.con-vs-popup >>> .vs-popup {
  width: 1200px !important;
  height: auto !important;
}
</style>
<style>
/* @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-layouts/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../node_modules/@syncfusion/ej2-vue-kanban/styles/material.css"; */

.e-card-wrapper {
  margin-bottom: 30px !important;
}

.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card {
  /* border: 1px solid #dee2e6!important; */
  border-radius: 6px !important;
  box-shadow: none !important;
  margin-bottom: 12px !important;
  min-height: 50px !important;
}

.kanban-overview.e-kanban .header-template-wrap {
  display: inline-flex;
  font-size: 15px;
  font-weight: 500;
}

.kanban-overview.e-kanban .header-template-wrap .header-icon {
  font-family: "Kanban priority icons";
  margin-top: 3px;
  width: 10%;
}

.kanban-overview.e-kanban .header-template-wrap .header-text {
  margin-left: 15px;
}

.kanban-overview.e-kanban.e-rtl .header-template-wrap .header-text {
  margin-right: 15px;
}

.kanban-overview.e-kanban.e-rtl .e-card-avatar {
  left: 12px;
  right: auto;
}

.kanban-overview.e-kanban .e-card-avatar {
  width: 30px;
  height: 30px;
  text-align: center;
  background-color: gainsboro;
  color: #6b6b6b;
  border-radius: 50%;
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 12px;
  font-weight: 400;
  padding: 10px 0px 0px 1px;
}

.kanban-overview.e-kanban .Open::before {
  content: "\e700";
  color: #0251cc;
  font-size: 16px;
}

.kanban-overview.e-kanban .InProgress::before {
  content: "\e703";
  color: #ea9713;
  font-size: 16px;
}

.kanban-overview.e-kanban .e-image img {
  background: #ececec;
  border: 1px solid #c8c8c8;
  border-radius: 50%;
}

.kanban-overview.e-kanban .Review::before {
  content: "\e701";
  color: #8e4399;
  font-size: 16px;
}

.kanban-overview.e-kanban .Close::before {
  content: "\e702";
  color: #63ba3c;
  font-size: 16px;
}

.kanban-overview.e-kanban .e-card .e-card-tag-field {
  border: 1px solid #dee2e6;
  background: #ececec;
  color: #6b6b6b;
  margin-right: 5px;
  line-height: 1.1;
  font-size: 13px;
  border-radius: 6px;
  padding: 4px;
}

.kanban-overview.e-kanban .e-card-custom-footer {
  display: flex;
  padding: 0px 12px 12px;
  line-height: 1;
  height: 35px;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.First.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.First,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.First {
  border-left: 3px solid #1f88e5;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Second.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Second,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Second {
  border-left: 3px solid #673ab8;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Third.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Third,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Third {
  border-left: 3px solid #02897b;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fourth.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fourth,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fourth {
  border-left: 3px solid #e64a19;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fiveth.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fiveth,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Fiveth {
  border-left: 3px solid #f7a51c;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Sixth.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Sixth,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Sixth {
  border-left: 3px solid #f71cdb;
}

.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Seventh.e-selection:hover,
.kanban-overview.e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Seventh,
.kanban-overview.e-kanban.e-rtl
  .e-kanban
  .e-kanban-content
  .e-content-row
  .e-content-cells
  .e-card-wrapper
  .e-card.Seventh {
  border-left: 3px solid #14cdeb;
}

@font-face {
  font-family: "Kanban priority icons";
  src: url(data:application/x-font-ttf;charset=utf-8;base64,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)
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

[class^="sf-icon-"],
[class*=" sf-icon-"] {
  font-family: "Kanban priority icons" !important;
  speak: none;
  font-size: 55px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
